__turbopack_context__.v({
  "background": "MainHero-module-scss-module__3e5Tsq__background",
  "backgroundImage": "MainHero-module-scss-module__3e5Tsq__backgroundImage",
  "content": "MainHero-module-scss-module__3e5Tsq__content",
  "ctaRow": "MainHero-module-scss-module__3e5Tsq__ctaRow",
  "desktopImage": "MainHero-module-scss-module__3e5Tsq__desktopImage",
  "headingGroup": "MainHero-module-scss-module__3e5Tsq__headingGroup",
  "hero": "MainHero-module-scss-module__3e5Tsq__hero",
  "infoCard": "MainHero-module-scss-module__3e5Tsq__infoCard",
  "large": "MainHero-module-scss-module__3e5Tsq__large",
  "mobileImage": "MainHero-module-scss-module__3e5Tsq__mobileImage",
  "overlay": "MainHero-module-scss-module__3e5Tsq__overlay",
  "revealed": "MainHero-module-scss-module__3e5Tsq__revealed",
  "subCopy": "MainHero-module-scss-module__3e5Tsq__subCopy",
  "title": "MainHero-module-scss-module__3e5Tsq__title",
});
